// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.control-panel {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-start;
  padding: 5px;
  gap: 5px;
  border-radius: 3px;
  background-color: #333;
}

.control-group {
  display: flex;
  flex-direction: column;
  border: 1px solid #555;
  border-radius: 3px;
  justify-content: center;
  flex-shrink: 0;
  padding: 2px;
}

.control-group.left {
  justify-content: left;
}

.control-group.horizontal {
  flex-direction: row;
  width: 100%;
}

.control-group.noborder {
  border: 0;
}

.horizontal-buttons {
  flex-direction: row;
  padding: 3px;
}

.control {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 1px;
  font-size: 0.75em;
}

.control-group label {
  margin-right: 10px;
}

button { /* stylelint-disable */
  border: 3px solid #222;
  border-style: groove;
  border-radius: 5px;
  background: #444;
  color: #888;
  padding: 0;
}

button.sm {
  padding: 2px;
  font-size: 0.75em;
  display: flex;
  justify-content: center;
  align-items: center;
}

button.fa {
  font-size: initial;
  padding: 2px;
  width: 22px;
  height: 22px;
}

button:focus {
  outline: none;
  border: 1px dotted darkorange;
}

.range {
}

.control label {
  margin-right: 3px;
  color: #888;
}

.control input {
  width: 40px;
  border: 1px solid black;
  background: #222;
  text-align: center;
  color: #888;
}

.range input:focus {
  outline: none;
  border: 1px dotted darkorange;
}

input.inline-editor {
  font-size: 0.75em;
}

input.inline-editor:focus {
  outline: none;
  border: none;
  background-color: rgba(0,128,0,0.5);
}

.control select {
  border: 1px solid black;
  color: #888;
}

.control .slider {
  min-width: 100px;
}

.slider.ui-slider {
  border-color: black;
  box-shadow: inset 1px 1px 3px #000;
  background-color: #444;
}

.slider .ui-slider-handle {
  border-radius: 50%;
  background: -moz-linear-gradient(top, rgba(181,189,200,1) 0%, rgba(130,140,149,1) 36%, rgba(40,52,59,1) 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(top, rgba(181,189,200,1) 0%,rgba(130,140,149,1) 36%,rgba(40,52,59,1) 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom, rgba(181,189,200,1) 0%,rgba(130,140,149,1) 36%,rgba(40,52,59,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  border-color: black;
  box-shadow: 1px 1px 3px #000;
}

.slider .ui-slider-handle:focus {
  outline: none;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #444;
  min-width: 160px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
  z-index: 1;
  padding: 5px;
  border: 2px solid black;
  border-style: groove;
}

.dropdown-content a {
  color: white;
  text-decoration: none;
  display: block;
}

.dropdown-content.show {
  display: block;
}

.background-overlay {
  background-color: rgba(0,0,0,0.5);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: none;
}

.background-overlay.show {
  display: block;
}

#dialog .control-group {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/controls.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,SAAS,sBAAsB;EAC7B,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;AACA;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,6GAA6G,EAAE,aAAa;EAC5H,8GAA8G,EAAE,4BAA4B;EAC5I,4GAA4G,EAAE,qDAAqD;EACnK,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;EAC3C,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".control-panel {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: flex-start;\n  padding: 5px;\n  gap: 5px;\n  border-radius: 3px;\n  background-color: #333;\n}\n\n.control-group {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #555;\n  border-radius: 3px;\n  justify-content: center;\n  flex-shrink: 0;\n  padding: 2px;\n}\n\n.control-group.left {\n  justify-content: left;\n}\n\n.control-group.horizontal {\n  flex-direction: row;\n  width: 100%;\n}\n\n.control-group.noborder {\n  border: 0;\n}\n\n.horizontal-buttons {\n  flex-direction: row;\n  padding: 3px;\n}\n\n.control {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin: 1px;\n  font-size: 0.75em;\n}\n\n.control-group label {\n  margin-right: 10px;\n}\n\nbutton { /* stylelint-disable */\n  border: 3px solid #222;\n  border-style: groove;\n  border-radius: 5px;\n  background: #444;\n  color: #888;\n  padding: 0;\n}\n\nbutton.sm {\n  padding: 2px;\n  font-size: 0.75em;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\nbutton.fa {\n  font-size: initial;\n  padding: 2px;\n  width: 22px;\n  height: 22px;\n}\n\nbutton:focus {\n  outline: none;\n  border: 1px dotted darkorange;\n}\n\n.range {\n}\n\n.control label {\n  margin-right: 3px;\n  color: #888;\n}\n\n.control input {\n  width: 40px;\n  border: 1px solid black;\n  background: #222;\n  text-align: center;\n  color: #888;\n}\n\n.range input:focus {\n  outline: none;\n  border: 1px dotted darkorange;\n}\n\ninput.inline-editor {\n  font-size: 0.75em;\n}\n\ninput.inline-editor:focus {\n  outline: none;\n  border: none;\n  background-color: rgba(0,128,0,0.5);\n}\n\n.control select {\n  border: 1px solid black;\n  color: #888;\n}\n\n.control .slider {\n  min-width: 100px;\n}\n\n.slider.ui-slider {\n  border-color: black;\n  box-shadow: inset 1px 1px 3px #000;\n  background-color: #444;\n}\n\n.slider .ui-slider-handle {\n  border-radius: 50%;\n  background: -moz-linear-gradient(top, rgba(181,189,200,1) 0%, rgba(130,140,149,1) 36%, rgba(40,52,59,1) 100%); /* FF3.6-15 */\n  background: -webkit-linear-gradient(top, rgba(181,189,200,1) 0%,rgba(130,140,149,1) 36%,rgba(40,52,59,1) 100%); /* Chrome10-25,Safari5.1-6 */\n  background: linear-gradient(to bottom, rgba(181,189,200,1) 0%,rgba(130,140,149,1) 36%,rgba(40,52,59,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n  border-color: black;\n  box-shadow: 1px 1px 3px #000;\n}\n\n.slider .ui-slider-handle:focus {\n  outline: none;\n}\n\n.dropdown-content {\n  display: none;\n  position: absolute;\n  background-color: #444;\n  min-width: 160px;\n  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n  padding: 5px;\n  border: 2px solid black;\n  border-style: groove;\n}\n\n.dropdown-content a {\n  color: white;\n  text-decoration: none;\n  display: block;\n}\n\n.dropdown-content.show {\n  display: block;\n}\n\n.background-overlay {\n  background-color: rgba(0,0,0,0.5);\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: none;\n}\n\n.background-overlay.show {\n  display: block;\n}\n\n#dialog .control-group {\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
